<template>
  <div class="mb-3">
    <text-input v-model="form.name" :error="form.errors.name" label="Type" />
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'

export default {
  name: 'TypeForm',
  components: {
    TextInput
  },
  props: {
    form: Object
  }
}
</script>

<style>

</style>
